'use strict';

module.exports = Object.freeze([
  'One Time',
  '1 x Year',
  '1 x Quarter',
  '1 x Month',
  '1 x Week',
  '1 x Day',
]);
